import * as XLSX from "xlsx";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { getColumn, removeColumn } from "./CreatePoints";

const ValidateSize = (file) => {
    var FileSize = file.size / 1024 / 1024;
    return FileSize <= 50;
};

const getMetadata = (csvData, type, rows) => {
    const METADATA_COLUMNS = {
        createdAt: ["date", "created at", "created at (utc)"],
        scannerId: ["scanner id", "scannerid", "device id"],
        createdBy: ["created by", "createdby"],
    };

    const metadataKeys = Object.keys(METADATA_COLUMNS);
    const metadataValues = Object.values(METADATA_COLUMNS);

    let metadata = {};

    for (let index = csvData[0].length; index >= 0; index--) {
        if (
            typeof csvData[0][index] === "string" ||
            isNaN(+csvData[0][index])
        ) {
            if (csvData[0][index]) {
                const metadatakey = metadataValues.findIndex((value) =>
                    value.includes(csvData[0][index].toLowerCase())
                );
                if (metadatakey > -1) {
                    metadata[metadataKeys[metadatakey]] = getColumn(
                        rows,
                        index
                    );
                }
            }
            if (index > 0 && type === "calibration") {
                removeColumn(rows, index);
                csvData[0].splice(index, 1);
            }
        }
    }
    return metadata;
};
const handleReadingFile = (
    event,
    errorHandler,
    completionHandler,
    type = "calibration"
) => {
    const key = event.target.name;
    if (event.target.files.length === 0) return;
    const file = event.target.files[0];

    const isValid = ValidateSize(file);
    // validate file size max 50 MB
    if (!isValid) {
        errorHandler();
        //translate("fileExceedSizeError")
        toast.error("File exceed the allowed size!", {
            position: "top-center",
        });
        return;
    }

    const filename = file.name;
    const reader = new FileReader();
    reader.onload = (evt) => {
        /* Parse data */
        let bstr = evt.target.result;
        bstr = bstr
            .split("\n")
            .map((b) => b.replace(/(\s*,?\s*)*$/, ""))
            .join("\n");
        const { data } = Papa.parse(bstr, {
            skipEmptyLines: true,
            transform: function (cell, index) {
                return index === 0 || isNaN(cell) ? cell : Number(cell);
            },
        });

        const csvData = data;
        let rows = csvData.slice(1);

        let metadata = getMetadata(csvData, type, rows);

        const modifiedResult = {
            headers: type === "calibration" ? csvData[0].splice(1) : csvData[0],
            rows,
            metadata,
        };
        completionHandler(key, filename, modifiedResult);
    };

    reader.readAsBinaryString(file);
};

const handleReadingFileRaw = (
    event,
    translate,
    errorHandler,
    completionHandler
) => {
    const key = event.target.name;
    if (event.target.files.length === 0) return;
    const file = event.target.files[0];

    const isValid = ValidateSize(file);
    // validate file size max 50 MB
    if (!isValid) {
        errorHandler();
        toast.error(translate("fileExceedSizeError"), {
            position: "top-center",
        });
        return;
    }

    const filename = file.name;
    const reader = new FileReader();
    reader.onload = (evt) => {
        /* Parse data */
        let base64data = evt.target.result;
        let data = base64data.substr(base64data.indexOf(",") + 1);
        completionHandler(key, filename, data);
    };

    reader.readAsDataURL(file);
};

const exportArrayToCSV = (data, fileName, sheetName = null) => {
    var wb = XLSX.utils.book_new();
    wb.SheetNames.push(sheetName ?? "Sheet 1");
    var ws = XLSX.utils.aoa_to_sheet(data);
    wb.Sheets[sheetName ?? "Sheet 1"] = ws;
    var csv = XLSX.utils.sheet_to_csv(ws);
    saveAs(new Blob([csv], { type: "text/csv" }), `${fileName}.csv`);
};

export { handleReadingFile, exportArrayToCSV, handleReadingFileRaw };
